import { Controller } from '@hotwired/stimulus';

const HIGHLIGHT_CLASS = 'staff-table__receipt-highlight';

export default class extends Controller {
  static values = { target: String };

  connect() {
    this.onLoad = () => this.scrollToTarget();
    document.addEventListener('turbo:load', this.onLoad);
    this.scrollToTarget();
  }

  disconnect() {
    document.removeEventListener('turbo:load', this.onLoad);
  }

  scrollToTarget() {
    const id = this.targetValue || window.location.hash.replace(/^#/, '');
    if (!id) return;

    this.attemptScroll(id, 0);
  }

  attemptScroll(id, attempt) {
    const target = document.getElementById(id);
    if (target) {
      target.classList.add(HIGHLIGHT_CLASS);
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (window.history.replaceState) {
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}#${id}`);
      }
      return;
    }

    if (attempt < 20) {
      window.setTimeout(() => this.attemptScroll(id, attempt + 1), 100);
    }
  }
}
